import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { Button } from "@/components/ui/button"
import BlobLayout from "@/components/layout/BlobLayout"

export const Route = createFileRoute("/access-denied")({
  component: AccessDenied,
})

export default function AccessDenied() {
  const navigate = useNavigate()

  return (
    <BlobLayout>
      <img src="/404/accessDenied.png" alt="deny" />
      <h1 className="z-10 font-mukta text-xl font-bold lg:text-6xl">
        Access Denied
      </h1>
      <p className="z-10 max-w-lg text-center font-mukta text-lg font-thin text-gray-400">
        You do not have permission to view this page or perform this action. If
        you believe this is a mistake, please contact the administrator.
      </p>
      <Button onClick={() => navigate({ to: "/" })}>Go to Home</Button>
    </BlobLayout>
  )
}
